import { render, staticRenderFns } from "./NaturalOrganic.vue?vue&type=template&id=56d1fc0c&scoped=true&"
import script from "./NaturalOrganic.vue?vue&type=script&lang=js&"
export * from "./NaturalOrganic.vue?vue&type=script&lang=js&"
import style0 from "./NaturalOrganic.vue?vue&type=style&index=0&id=56d1fc0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d1fc0c",
  null
  
)

export default component.exports